import Main from '@/components/Main/Main.vue'

/**
 * menuHide: 为true时不在导航栏中显示
 *
 * */

export default [
  {
    path: '/',
    name: '_index',
    meta: {
      title: '共享洗衣',
      menuHide: true
    },
    component: Main,
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'index',
        meta: {
          title: '共享洗衣官网'
        },
        component: () => import('@/view/index/index.vue')
      }
    ]
  },
  {
    path: '/washer',
    name: '_washer',
    meta: {
      title: '洗衣模块'
    },
    component: Main,
    children: [
      {
        path: 'washer',
        name: 'washer',
        meta: {
          title: '洗衣模块'
        },
        component: () => import('@/view/washer/washer.vue')
      }
    ]
  },
  {
    path: '/shared',
    name: '_shared',
    meta: {
      title: '共享空间'
    },
    component: Main,
    children: [
      {
        path: 'space',
        name: 'space',
        meta: {
          title: '共享空间'
        },
        component: () => import('@/view/space/space.vue')
      }
    ]
  },
  {
    path: '/product',
    name: '_product',
    meta: {
      title: '产品介绍'
    },
    component: Main,
    children: [
      {
        path: 'product',
        name: 'product',
        meta: {
          title: '产品介绍'
        },
        component: () => import('@/view/product/product.vue')
      }
    ]
  },
  {
    path: '/partner',
    name: '_partner',
    meta: {
      title: '城市合伙人'
    },
    component: Main,
    children: [
      {
        path: 'partner',
        name: 'partner',
        meta: {
          title: '城市合伙人'
        },
        component: () => import('@/view/partner/partner.vue')
      }
    ]
  },
  {
    path: '/aboutUs',
    name: '_aboutUs',
    meta: {
      title: '关于我们'
    },
    component: Main,
    children: [
      {
        path: 'aboutUs',
        name: 'aboutUs',
        meta: {
          title: '关于我们'
        },
        component: () => import('@/view/aboutUs/aboutUs.vue')
      }
    ]
  },
  {
    path: '/details',
    name: '_details',
    meta: {
      title: '新闻及案例详情',
      menuHide: true
    },
    component: Main,
    children: [
      {
        path: 'details',
        name: 'details',
        meta: {
          title: '详情'
        },
        component: () => import('@/view/details/details.vue')
      }
    ]
  },
  {
    path: '/contact',
    name: '_contact',
    meta: {
      title: '联系我们'
    },
    component: Main,
    children: [
      {
        path: 'contact',
        name: 'contact',
        meta: {
          title: '联系我们'
        },
        component: () => import('@/view/contact/contact.vue')
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/router.js